import { TranslationKeys } from '~frontend-common/i18n/english/faq.i18n';

const keys: TranslationKeys = {
  faq: {
    description: 'Apprenez en plus sur votre police d’assurance ou sur le fonctionnement de YouSet.',
    title: "À la recherche de plus d'info?",
    visitFaq: 'Consultez notre FAQ',
  },
};

export default keys;
